// PlanContext.js
// Stripe and subscription plans have been removed.
// All features are free. This context is kept as a stub so existing
// component imports do not break — it simply returns neutral values everywhere.

import React, { createContext, useContext } from 'react';

const PlanContext = createContext();

export const usePlan = () => {
  const context = useContext(PlanContext);
  if (!context) throw new Error('usePlan must be used within a PlanProvider');
  return context;
};

export const PLANS = {
  FREE: 'free',
};

export const PlanProvider = ({ children }) => {
  const value = {
    plan: 'free',
    planLoading: false,
    planData: null,
    planName: 'free',
    // All feature gates return open — no paywalls
    isFree: false,
    isProActive: false,
    isLifetimeOrPro: false,
    hasAccess: () => true,
    // Upload system — unlimited for everyone
    uploadCredits: Infinity,
    freeUploadsRemaining: Infinity,
    needsUploadCredit: false,
    canPurchaseCredits: false,
    PLANS,
  };

  return (
    <PlanContext.Provider value={value}>
      {children}
    </PlanContext.Provider>
  );
};